<div class="auth-code-page" authTheme>
    <app-confetti/>
    <div class="auth-code-container auth-code-container--success">
        <div class="text-center mb-4">
            <img src="assets/images/logo-icon.png" alt="ADN Logo" class="login-logo" />
            <h2 class="h3 mb-2">{{ title }}</h2>
            <p class="text-muted">{{ subtitle }}</p>
            <div class="d-flex justify-content-center align-items-center display-1 mb-3">
                <i class="bi bi-check-circle-fill"></i>
            </div>
            <p><b>{{ actionText }}</b></p>
        </div>
    </div>
</div>
